import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=6fa12c9d&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenter.vue?vue&type=style&index=0&id=6fa12c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa12c9d",
  null
  
)

export default component.exports